module.exports = __webpack_public_path__ + "static/di-hero-mobile.b22314c4.webp";